import { formatToCurrencyType } from "../../helper/common";
import { FIELD_TYPE } from "../../type/fileType";

const { INPUT, COMBO_BOX, CURRENCY } = FIELD_TYPE;

const columnsTableOneCourse = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    align: "center",
  },
  {
    title: "Mã khóa lẻ",
    dataIndex: "code",
    key: "code",
  },
  {
    title: "Tên khóa lẻ",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Số tiền",
    dataIndex: "listPrice",
    key: "listPrice",
    align: "center",
    render: (_, record) => {
      return <div>{formatToCurrencyType(record.listPrice)}</div>;
    },
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    align: "center",
  },
];

const columnsTableComboCourse = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    align: "center",
  },
  {
    title: "Mã combo",
    dataIndex: "code",
    key: "code",
  },
  {
    title: "Tên combo",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Số tiền",
    dataIndex: "fixedPrice",
    key: "fixedPrice",
    align: "center",
    render: (_, record) => {
      return <div>{formatToCurrencyType(record.fixedPrice)}</div>;
    },
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    align: "center",
  },
];

const dataOnceCourse = [
  {
    type: INPUT,
    label: "Tên khóa lẻ",
    name: "name",
    rules: [{ required: true, message: "Chưa nhập tên" }],
  },
  {
    type: CURRENCY,
    label: "Giá bán",
    name: "listPrice",
    rules: [{ required: true, message: "Chưa nhập giá bán" }],
  },
  {
    type: INPUT,
    label: "Mã khóa lẻ",
    name: "code",
    rules: [{ required: true, message: "Chưa nhập mật khẩu" }],
  },
];

const dataComboCourse = [
  {
    type: INPUT,
    label: "Tên combo",
    name: "name",
    rules: [{ required: true, message: "Chưa nhập tài khoản" }],
  },
  {
    type: INPUT,
    label: "Mã combo",
    name: "code",
    rules: [{ required: true, message: "Chưa nhập mã combo" }],
  },
  {
    type: CURRENCY,
    label: "Giá fix",
    name: "fixedPrice",
    rules: [{ required: true, message: "Chưa nhập giá fix" }],
  },
  {
    type: COMBO_BOX,
    label: "Combo",
    name: "items",
    rules: [{ required: true, message: "Chưa chọn khóa lẻ" }],
    mode: "multiple",
  },
  {
    type: CURRENCY,
    label: "Giá bán",
    disable: true,
    name: "price",
  },
];

const oneCourseSearch = [
  {
    type: INPUT,
    label: "Tên khóa lẻ",
    name: "keyword",
  },
];

const comboSearch = [
  {
    type: INPUT,
    label: "Tên combo",
    name: "keyword",
  },
];

export {
  columnsTableOneCourse,
  columnsTableComboCourse,
  dataOnceCourse,
  dataComboCourse,
  oneCourseSearch,
  comboSearch,
};
